module.exports = __webpack_public_path__ + "static/img/logo_2 - 副本.43658e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_2 - 副本.png
// module id = OOUz
// module chunks = 0